import { ShieldCheck, Wrench, Clock, BadgeCheck } from "lucide-react";

const WhyChooseUs = () => {
    const features = [
        {
            icon: <ShieldCheck size={40} className="wcu-hob-icon" />,
            title: "Trusted & Verified",
            desc: "Our contractors are background-verified and trained to deliver the highest construction standards."
        },
        {
            icon: <Wrench size={40} className="wcu-hob-icon" />,
            title: "Expert Engineers",
            desc: "Skilled professionals with years of hands-on experience in construction."
        },
        {
            icon: <Clock size={40} className="wcu-hob-icon" />,
            title: "On-Time Delivery",
            desc: "We value your time and ensure punctual, efficient project completion every time."
        },
        {
            icon: <BadgeCheck size={40} className="wcu-hob-icon" />,
            title: "Strong Network",
            desc: "Lokesh Mandal Constructions ensures quality workmanship across Mumbai."
        }
    ];

    return (
        <section className="wcu-hob-section">
            <div className="wcu-hob-container">
                <h2 className="wcu-hob-title">Why Choose Us</h2>
                <p className="wcu-hob-subtitle">Lokesh Mandal Constructions trusted for the quality</p>
                <div className="wcu-hob-grid">
                    {features.map((item, index) => (
                        <div className="wcu-hob-card" key={index}>
                            <div className="wcu-hob-icon-wrapper">{item.icon}</div>
                            <h3 className="wcu-hob-card-title">{item.title}</h3>
                            <p className="wcu-hob-card-desc">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;